module.exports = __webpack_public_path__ + "static/media/18.174306a4.mp3";